import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash;
      const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
      if (!sid) {
        navigate("/");
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard");
      } catch (e) {
        navigate("/auth");
      }
    };
    run();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="font-display font-extrabold text-2xl animate-pulse">Signing you in…</div>
    </div>
  );
};
